module.exports = __webpack_public_path__ + "static/media/news_p2_2.c34384ff.png";